<ng-container *transloco="let t">
  @if (fetchingUser()) {
    <div class="flex h-[30rem] flex-col items-center justify-center">
      <IIcon name="loading" class="animate-spin text-2xl font-medium text-gray-300" />
    </div>
  } @else {
    @if (tokenExpired()) {
      <div class="flex h-[30rem] flex-col items-center justify-center">
        <h1 class="text-2xl font-semibold">{{ t("register-invite.link_expired") }}</h1>
        <p class="text-sm text-gray-500">{{ t("register-invite.link_expired_description") }}</p>
      </div>
    } @else {
      <IRegisterForm
        [user]="user()"
        (register)="registerInvite($event)"
        [loading]="registerLoading()"
        [agencyName]="agency"
        [termsAndConditionLink]="termsAndConditionLink"
        [inviteMode]="true"
      />
    }
  }
</ng-container>
